import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const CompanyNameInput = () => {
  return <VpHookFormInput maxLength={50} required name="companyName" placeholder="Company Name" />;
};

export default CompanyNameInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-up/CompanyNameInput.jsx